const CatalogAdsActions = {
    SET_ADS: 'SET_ADS',
    LOAD_CATALOG_ADS_ACTION: 'LOAD_CATALOG_ADS_ACTION',
    SET_BUYER_ASSIST_URL: 'SET_BUYER_ASSIST_URL',
};

export { CatalogAdsActions };